// extracted by mini-css-extract-plugin
export default {"container":"Background_container__v9eS6","space":"Background_space__FtxPw","spin":"Background_spin__PlIHv","rotateIn":"Background_rotateIn__+-qmz"};